import {FormFieldType} from "../enums/form-field-type.enum";

export function fieldTypeHasOptions(value: string): boolean {
  const fieldType = value as FormFieldType;
  return fieldType === FormFieldType.SELECT || fieldType === FormFieldType.RADIO || fieldType === FormFieldType.MULTI_CHECKBOX;
}
